import React from "react";
import {
  Box,
  Button,
} from "@mui/material";
import {
  NavLink,
  useNavigate,
} from "react-router-dom";
import { useDispatch } from "react-redux";

import { clearSearch } from "../features/searchSlice";
import { setSelectedCategoryId } from "../features/categoriesSlice";

const pages = [
  // {
  //   name: "דף הבית",
  //   url: "/",
  // },
  {
    name: "מוצרים",
    url: "/products",
  },
  {
    name: "תקנון משלוחים",
    url: "/shipping-policy",
  },
  {
    name: "צור קשר",
    url: "/contact",
  },
  {
    name: "אודות",
    url: "/about",
  },
];

const Nav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickNavigate = (
    event,
    url
  ) => {
    /*
     * אנחנו מונעים את הניווט האוטומטי של הקישור,
     * מבצעים את האיפוסים הדרושים ולאחר מכן מנווטים.
     */
    event.preventDefault();

    if (url === "/products") {
      dispatch(clearSearch());
      dispatch(
        setSelectedCategoryId(-1)
      );
    }

    navigate(url);
  };

  return (
    <Box
      component="nav"
      aria-label="ניווט ראשי באתר"
      sx={{
        flexGrow: 1,
        display: {
          xs: "none",
          md: "flex",
        },
        alignItems: "center",
        justifyContent: "center",
        gap: 1,

        /*
         * מסגרת ברורה כאשר עוברים עם Tab.
         */
        "& a:focus-visible": {
          outline:
            "3px solid #000000",
          outlineOffset: "3px",
          borderRadius: "6px",
        },
      }}
    >
      {pages.map((page) => (
        <Button
          key={page.url}
          component={NavLink}
          to={page.url}
          end={page.url === "/"}
          onClick={(event) =>
            handleClickNavigate(event, page.url)
          }
          sx={{
            my: 1,
            px: 1.5,
            py: 1,
            minHeight: 44,
            minWidth: 44,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#287A3D",
            fontSize: "18px",
            fontWeight: 600,
            lineHeight: 1.4,
            textTransform: "none",
            whiteSpace: "nowrap",
            borderRadius: "6px",
            textDecoration: "none",

            "&:link": {
              color: "#287A3D",
            },

            "&:visited": {
              color: "#287A3D",
            },

            "&:hover": {
              color: "#1F6B34",
              backgroundColor: "rgba(40, 122, 61, 0.10)",
              textDecoration: "underline",
            },

            "&:focus-visible": {
              color: "#287A3D",
              outline: "3px solid #287A3D",
              outlineOffset: "3px",
              backgroundColor: "rgba(40, 122, 61, 0.14)",
              textDecoration: "underline",
            },

            '&[aria-current="page"]': {
              color: "#287A3D",
              fontWeight: 800,
              backgroundColor: "rgba(40, 122, 61, 0.14)",
              textDecoration: "underline",
              textUnderlineOffset: "5px",
              textDecorationThickness: "2px",
            },

            '&[aria-current="page"]:hover': {
              color: "#1F6B34",
            },

            '&[aria-current="page"]:focus-visible': {
              color: "#287A3D",
              outline: "3px solid #287A3D",
              outlineOffset: "3px",
            },
          }}
        >
          {page.name}
        </Button>
      ))}
    </Box>
  );
};

export default Nav;